import { useCallback } from "react";
import { useNavigate, NavigateOptions } from "react-router-dom";
import { getApplicationId, getConfigId } from "../storage";

// Every page navigation must carry config_id and application_id so the
// destination page (or the native app, via the tbn-app:// deep link) still
// knows which tenant/app it's serving. Neither is threaded through component
// state — both are read from storage (see useLoginPage.ts, which persists
// them there) so callers never need to pass them explicitly.
export function buildNavigatePath(path: string): string {
  const params = new URLSearchParams();

  const configId = getConfigId();
  if (configId) params.set("config_id", configId);

  const applicationId = getApplicationId();
  if (applicationId) params.set("application_id", applicationId);

  const query = params.toString();
  if (!query) return path;

  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}${query}`;
}

export type AppNavigate = (path: string, options?: NavigateOptions) => void;

export function useAppNavigate(): AppNavigate {
  const navigate = useNavigate();

  return useCallback(
    (path, options) => {
      navigate(buildNavigatePath(path), options);
    },
    [navigate],
  );
}
